// Mock data for CNGTPL website

export const services = [
{
  id: 1,
  title: "Solar EPC & Installation",
  icon: "Sun",
  description: "Complete solar power solutions including rooftop solar, ground-mounted systems, and turnkey EPC services.",
  link: "https://solar.cngtpl.com",
  external: true
},
{
  id: 2,
  title: "EV Charging Solutions",
  icon: "Zap",
  description: "Smart EV charging infrastructure for homes, offices, and public spaces with IoT-enabled solutions.",
  link: "https://solar.cngtpl.com",
  external: true
},
{
  id: 3,
  title: "Software & AI Services",
  icon: "Code",
  description: "Custom software development, AI chatbots, automation solutions, and digital transformation services.",
  link: "/software-ai-services"
},
{
  id: 4,
  title: "ERP / AMC Solutions",
  icon: "Database",
  description: "School, hospital, manufacturing ERP systems, CRM solutions, and comprehensive AMC services.",
  link: "/erp-amc-solutions"
},
{
  id: 5,
  title: "IoT & Smart City Solutions",
  icon: "Cpu",
  description: "IoT infrastructure, smart city platforms, intelligent sensors, connected devices, and data analytics for urban transformation.",
  link: "/iot-smart-city"
},
{
  id: 6,
  title: "Cyber Security Services",
  icon: "ShieldCheck",
  description: "VAPT testing, security audits, cybersecurity training, and compliance consulting services.",
  link: "/cybersecurity-services"
},
{
  id: 7,
  title: "Outsource Support",
  icon: "Headphones",
  description: "Customer support, back office operations, lead generation, and tech support services.",
  link: "/outsource-support"
},
{
  id: 8,
  title: "Manpower Services",
  icon: "Users",
  description: "IT & Non-IT staffing, contract hiring, permanent placement, and bulk recruitment solutions.",
  link: "/manpower-services"
},
{
  id: 9,
  title: "Training & Placement",
  icon: "GraduationCap",
  description: "Full stack development, AI/ML, digital marketing, soft skills training with placement assistance.",
  link: "/training-placement"
},
{
  id: 10,
  title: "CCTV Installation & AMC",
  icon: "Camera",
  description: "Comprehensive surveillance solutions for defence, government, hotels, hospitals, educational institutes, and infrastructure with installation and AMC.",
  link: "/cctv-surveillance"
}];


export const whyChooseUs = [
{
  icon: "Award",
  title: "7+ Years Experience",
  description: "Since 2018, delivering excellence in technology and workforce solutions"
},
{
  icon: "Users",
  title: "Skilled Team",
  description: "Expert professionals across all domains"
},
{
  icon: "MapPin",
  title: "PAN India Support",
  description: "Serving clients across India with dedicated support"
},
{
  icon: "DollarSign",
  title: "Cost Effective",
  description: "Premium solutions at competitive prices"
},
{
  icon: "Sparkles",
  title: "AI Driven Growth",
  description: "Leveraging latest AI technologies for business growth"
},
{
  icon: "Shield",
  title: "Trusted Partner",
  description: "Reliable and transparent business relationships"
}];


export const industries = [
{ name: "Education", icon: "BookOpen" },
{ name: "Healthcare", icon: "Heart" },
{ name: "Retail", icon: "ShoppingCart" },
{ name: "Manufacturing", icon: "Factory" },
{ name: "Real Estate", icon: "Building" },
{ name: "Finance", icon: "DollarSign" },
{ name: "Logistics", icon: "Truck" },
{ name: "Startups", icon: "Rocket" }];


export const testimonials = [
{
  id: 1,
  name: "Mr. Rajesh Kumar",
  company: "",
  role: "",
  content: "CNGTPL transformed our business with their AI-powered CRM solution. The team's expertise and support were exceptional.",
  rating: 5
},
{
  id: 2,
  name: "Prof. Priya Sharma",
  company: "",
  role: "",
  content: "Their School Management ERP has streamlined our entire operations. Highly recommended for educational institutions!",
  rating: 5
},
{
  id: 3,
  name: "Mr. Amit Patel",
  company: "",
  role: "",
  content: "Outstanding customer support and technical expertise. The outsourced support team is professional and efficient.",
  rating: 5
}];


export const companyInfo = {
  name: "Cosmos Next Gen Tech Private Limited",
  shortName: "CNGTPL",
  tagline: "Empowering Businesses with Technology, Talent & Transformation",
  address: "26, Gurunanakpura Road, Laxmi Nagar, New Delhi - 110092",
  phone: "+91 9315649601",
  email: "hello@cngtpl.in",
  whatsapp: "+919315649601"
};


// Company milestones - Updated year to 2018
export const milestones = [
{ year: "2018", event: "Company Founded", desc: "Started our journey in technology solutions" },
{ year: "2019", event: "First Major ERP Deployment", desc: "Successfully deployed enterprise solutions" },
{ year: "2020", event: "Expanded to Outsource Services", desc: "Launched support and BPO division" },
{ year: "2021", event: "Launched AI Solutions Division", desc: "Pioneered AI-powered business solutions" },
{ year: "2023", event: "1000+ Successful Projects", desc: "Milestone achievement in project delivery" },
{ year: "2024", event: "Pan India Operations", desc: "Expanded presence across entire India" }];


// Core Values
export const coreValues = [
{
  title: "Innovation",
  description: "Constantly evolving with latest technologies to deliver cutting-edge solutions",
  icon: "Lightbulb"
},
{
  title: "Integrity",
  description: "Transparent and honest business practices that build lasting trust",
  icon: "Shield"
},
{
  title: "Customer Success",
  description: "Your growth is our priority - we succeed when you succeed",
  icon: "Target"
},
{
  title: "Excellence",
  description: "Delivering quality in every project with attention to detail",
  icon: "Award"
}];


// Cyber Security Services
export const cyberSecurityServices = [
{
  title: "VAPT (Vulnerability Assessment & Penetration Testing)",
  icon: "Shield",
  description: "Comprehensive security testing to identify vulnerabilities before hackers do. We simulate real-world attacks on your web applications, APIs, and network infrastructure.",
  features: [
  "Web Application Security Testing",
  "API Security Assessment",
  "Network Penetration Testing",
  "Mobile App Security Testing",
  "Infrastructure Vulnerability Scanning",
  "Detailed Reporting with Remediation Steps"]

},
{
  title: "Corporate Cybersecurity Training",
  icon: "GraduationCap",
  description: "Build a security-first culture with role-based cybersecurity awareness training for your employees and teams.",
  features: [
  "Security Awareness Programs",
  "Phishing Simulation Training",
  "Role-based Security Training",
  "Incident Response Training",
  "Compliance Training (GDPR, HIPAA)",
  "Custom Training Modules"]

},
{
  title: "Cybersecurity Workshops",
  icon: "Users",
  description: "Hands-on workshops with ethical hacking labs, threat hunting exercises, and real-world scenarios.",
  features: [
  "Ethical Hacking Labs",
  "Capture The Flag (CTF) Competitions",
  "Threat Hunting Workshops",
  "Security Tools Training",
  "Real-world Case Studies",
  "Certification Preparation"]

},
{
  title: "Cyber Law Consulting",
  icon: "Scale",
  description: "Expert guidance on cyber law compliance including IT Act, GDPR, HIPAA, and industry-specific regulations.",
  features: [
  "IT Act 2000 Compliance",
  "GDPR Compliance Consulting",
  "HIPAA Compliance",
  "Data Protection Laws",
  "Incident Response Legal Support",
  "Policy Development"]

},
{
  title: "Data Recovery Services",
  icon: "HardDrive",
  description: "Enterprise-grade data recovery services with secure handling and precision recovery techniques.",
  features: [
  "Hard Drive Recovery",
  "RAID Data Recovery",
  "SSD Recovery",
  "Database Recovery",
  "Cloud Data Recovery",
  "Forensic Data Recovery"]

},
{
  title: "Infrastructure Security Testing",
  icon: "Server",
  description: "Comprehensive audit of your network infrastructure, firewalls, access controls, and security configurations.",
  features: [
  "Network Security Audit",
  "Firewall Configuration Review",
  "Access Control Assessment",
  "Cloud Security Testing",
  "Wireless Network Security",
  "Security Architecture Review"]

}];


export const cyberSecurityBenefits = [
"Real-world testing & reporting",
"Affordable & ethical services",
"Quick turnaround time (3-5 days)",
"Student & startup friendly pricing",
"Deep community experience",
"Certified security experts",
"24/7 incident support",
"Compliance-ready solutions"];


// FAQ Data
export const faqs = {
  general: [
  {
    question: "What services does CNGTPL provide?",
    answer: "We offer comprehensive technology and workforce solutions including Software & AI Development, ERP/AMC Solutions, Cyber Security Services, Outsource Support, Manpower Services, and Training & Placement programs."
  },
  {
    question: "Where is CNGTPL located?",
    answer: "Our office is located at 26, Gurunanakpura Road, Laxmi Nagar, New Delhi - 110092. We serve clients across Pan India."
  },
  {
    question: "How can I get a quote for my project?",
    answer: "You can request a quote by filling out our contact form, calling us at +91 9315649601, or sending us a WhatsApp message. We provide free consultations to understand your requirements."
  },
  {
    question: "Do you work with startups and small businesses?",
    answer: "Absolutely! We specialize in providing cost-effective solutions for startups, SMEs, and large enterprises. Our pricing is flexible and tailored to your business size."
  },
  {
    question: "What is your project delivery timeline?",
    answer: "Project timelines vary based on complexity and scope. Typically, small projects take 2-4 weeks, medium projects 1-3 months, and large-scale implementations 3-6 months. We provide detailed timelines during consultation."
  }],

  software: [
  {
    question: "What technologies do you use for development?",
    answer: "We use modern tech stacks including React, Node.js, Python, Laravel, Flutter for mobile apps, and AI/ML tools like TensorFlow. We choose the best technology based on your project requirements."
  },
  {
    question: "Do you provide post-deployment support?",
    answer: "Yes, we offer comprehensive AMC (Annual Maintenance Contract) services including bug fixes, updates, security patches, and technical support."
  },
  {
    question: "Can you integrate AI into my existing application?",
    answer: "Yes, we specialize in AI integration including chatbots, automation, predictive analytics, and machine learning models into existing systems."
  },
  {
    question: "Do you sign NDA for projects?",
    answer: "Yes, we sign NDAs and maintain strict confidentiality for all client projects. Your data and intellectual property are completely secure."
  }],

  cybersecurity: [
  {
    question: "What is VAPT and why do I need it?",
    answer: "VAPT (Vulnerability Assessment & Penetration Testing) simulates real attacks on your systems to find weak points before hackers do. It's essential for protecting your business data and maintaining customer trust."
  },
  {
    question: "Will my data be safe during security tests?",
    answer: "Yes, we sign NDAs and follow strict ethical standards. All testing is done in controlled environments with your permission, and we never compromise your data."
  },
  {
    question: "How soon can I get a security report?",
    answer: "Depending on the scope, we usually deliver comprehensive reports within 3-5 days of completing testing, including detailed findings and remediation steps."
  },
  {
    question: "Is cybersecurity training mandatory for employees?",
    answer: "While not always mandatory, it's highly recommended. Security awareness training significantly reduces risks of phishing attacks, data breaches, and human errors."
  }],

  staffing: [
  {
    question: "How quickly can you provide candidates?",
    answer: "We can provide shortlisted candidates within 3-7 days depending on the role complexity. Our database includes pre-verified professionals across all domains."
  },
  {
    question: "Do you provide replacement guarantee?",
    answer: "Yes, we offer a replacement guarantee period. If a candidate doesn't work out during the initial period, we provide a free replacement."
  },
  {
    question: "Can you handle bulk hiring requirements?",
    answer: "Yes, we specialize in bulk hiring and can scale our recruitment team based on your requirements. We've successfully handled 50+ candidate placements in single projects."
  }],

  training: [
  {
    question: "Are your training programs certified?",
    answer: "Yes, all our training programs come with industry-recognized certificates upon successful completion."
  },
  {
    question: "Do you provide placement assistance?",
    answer: "Yes, we offer dedicated placement assistance including resume building, mock interviews, and direct connections with our hiring partners."
  },
  {
    question: "Can working professionals join part-time batches?",
    answer: "Yes, we offer flexible batch timings including weekend and evening batches specifically designed for working professionals."
  }]

};

// Blog Posts Data
export const blogPosts = [
{
  id: 1,
  title: "AI Revolution in 2025: How Generative AI is Transforming Business Operations",
  slug: "ai-revolution-2025-generative-ai-transforming-business",
  category: "Artificial Intelligence",
  author: "CNGTPL Tech Team",
  date: "2025-01-10",
  readTime: "8 min read",
  excerpt: "Explore how generative AI models like GPT-5 and Gemini are revolutionizing business processes, from customer service automation to creative content generation.",
  image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800"
},
{
  id: 2,
  title: "The Future of Cloud Computing: Multi-Cloud and Edge Computing Trends",
  slug: "future-cloud-computing-multi-cloud-edge-trends",
  category: "Cloud Computing",
  author: "CNGTPL Tech Team",
  date: "2025-01-08",
  readTime: "6 min read",
  excerpt: "Discover why businesses are adopting multi-cloud strategies and how edge computing is reshaping data processing in 2025.",
  image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800"
},
{
  id: 3,
  title: "Cybersecurity Threats in 2025: Protecting Your Business from Modern Attacks",
  slug: "cybersecurity-threats-2025-protecting-business",
  category: "Cybersecurity",
  author: "CNGTPL Tech Team",
  date: "2025-01-05",
  readTime: "7 min read",
  excerpt: "Learn about emerging cybersecurity threats including AI-powered attacks, ransomware evolution, and essential protection strategies for your organization.",
  image: "https://images.unsplash.com/photo-1614064548237-096f735f344f?w=800"
},
{
  id: 4,
  title: "Low-Code/No-Code Platforms: Democratizing Software Development",
  slug: "low-code-no-code-platforms-democratizing-development",
  category: "Software Development",
  author: "CNGTPL Tech Team",
  date: "2025-01-03",
  readTime: "5 min read",
  excerpt: "How low-code and no-code platforms are enabling citizen developers and accelerating digital transformation across industries.",
  image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800"
},
{
  id: 5,
  title: "Remote Work Technology: Tools and Trends Shaping the Future of Work",
  slug: "remote-work-technology-tools-trends-2025",
  category: "Digital Transformation",
  author: "CNGTPL Tech Team",
  date: "2024-12-28",
  readTime: "6 min read",
  excerpt: "Explore the latest collaboration tools, virtual reality workspaces, and productivity platforms transforming remote and hybrid work models.",
  image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800"
},
{
  id: 6,
  title: "Blockchain Beyond Cryptocurrency: Real-World Enterprise Applications",
  slug: "blockchain-beyond-crypto-enterprise-applications",
  category: "Blockchain",
  author: "CNGTPL Tech Team",
  date: "2024-12-25",
  readTime: "7 min read",
  excerpt: "Discover how enterprises are leveraging blockchain for supply chain management, smart contracts, and decentralized identity verification.",
  image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=800"
},
{
  id: 7,
  title: "The Rise of Sustainable Tech: Green Computing and Carbon-Neutral Data Centers",
  slug: "sustainable-tech-green-computing-carbon-neutral",
  category: "Technology Trends",
  author: "CNGTPL Tech Team",
  date: "2024-12-22",
  readTime: "6 min read",
  excerpt: "How tech companies are embracing sustainability with energy-efficient algorithms, renewable energy-powered data centers, and eco-friendly practices.",
  image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800"
},
{
  id: 8,
  title: "5G and IoT Integration: Unlocking Smart City Potential",
  slug: "5g-iot-integration-smart-city-potential",
  category: "IoT & 5G",
  author: "CNGTPL Tech Team",
  date: "2024-12-20",
  readTime: "8 min read",
  excerpt: "Explore how 5G networks are enabling massive IoT deployments in smart cities, from traffic management to environmental monitoring.",
  image: "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=800"
},
{
  id: 9,
  title: "Quantum Computing: From Theory to Practical Business Applications",
  slug: "quantum-computing-theory-practical-business",
  category: "Emerging Technology",
  author: "CNGTPL Tech Team",
  date: "2024-12-18",
  readTime: "9 min read",
  excerpt: "Understanding quantum computing breakthroughs and their potential impact on cryptography, drug discovery, and financial modeling.",
  image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800"
},
{
  id: 10,
  title: "DevOps Evolution: GitOps, Platform Engineering, and Developer Experience",
  slug: "devops-evolution-gitops-platform-engineering",
  category: "DevOps",
  author: "CNGTPL Tech Team",
  date: "2024-12-15",
  readTime: "7 min read",
  excerpt: "Latest DevOps trends including GitOps practices, internal developer platforms, and automation strategies for faster software delivery.",
  image: "https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?w=800"
},
{
  id: 11,
  title: "Data Privacy Regulations 2025: GDPR, CCPA, and Global Compliance",
  slug: "data-privacy-regulations-2025-global-compliance",
  category: "Legal & Compliance",
  author: "CNGTPL Tech Team",
  date: "2024-12-12",
  readTime: "6 min read",
  excerpt: "Navigate the complex landscape of data privacy laws and learn how to ensure your business stays compliant across different jurisdictions.",
  image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800"
},
{
  id: 12,
  title: "Microservices Architecture: Best Practices and Common Pitfalls",
  slug: "microservices-architecture-best-practices-pitfalls",
  category: "Software Architecture",
  author: "CNGTPL Tech Team",
  date: "2024-12-10",
  readTime: "8 min read",
  excerpt: "Learn the dos and don'ts of microservices implementation, from service decomposition to inter-service communication patterns.",
  image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800"
},
{
  id: 13,
  title: "API Economy: Building and Monetizing Developer-First Products",
  slug: "api-economy-building-monetizing-developer-products",
  category: "API Development",
  author: "CNGTPL Tech Team",
  date: "2024-12-08",
  readTime: "7 min read",
  excerpt: "How API-first companies are creating new revenue streams and building ecosystems around their developer platforms.",
  image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800"
},
{
  id: 14,
  title: "ERP Modernization: Migrating Legacy Systems to Cloud-Native Solutions",
  slug: "erp-modernization-legacy-cloud-native",
  category: "Enterprise Software",
  author: "CNGTPL Tech Team",
  date: "2024-12-05",
  readTime: "9 min read",
  excerpt: "Strategic approaches to modernizing legacy ERP systems, including phased migration strategies and integration patterns.",
  image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800"
},
{
  id: 15,
  title: "The Skills Gap Crisis: Upskilling Your Workforce for the AI Era",
  slug: "skills-gap-upskilling-workforce-ai-era",
  category: "Workforce Development",
  author: "CNGTPL Tech Team",
  date: "2024-12-02",
  readTime: "6 min read",
  excerpt: "Addressing the growing skills gap in technology with effective training programs, reskilling initiatives, and talent development strategies.",
  image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800"
},
{
  id: 16,
  title: "Zero Trust Security Architecture: The Future of Enterprise Cybersecurity",
  slug: "zero-trust-security-architecture-enterprise",
  category: "Cybersecurity",
  author: "CNGTPL Security Team",
  date: "2025-01-15",
  readTime: "8 min read",
  excerpt: "Learn how Zero Trust principles are revolutionizing enterprise security by eliminating implicit trust and continuously verifying every access request.",
  image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800"
},
{
  id: 17,
  title: "Ransomware Defense Strategies: Protecting Your Business in 2025",
  slug: "ransomware-defense-strategies-2025",
  category: "Cybersecurity",
  author: "CNGTPL Security Team",
  date: "2025-01-12",
  readTime: "7 min read",
  excerpt: "Comprehensive guide to defending against modern ransomware attacks including prevention, detection, response strategies, and recovery planning.",
  image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800"
},
{
  id: 18,
  title: "API Security Best Practices: Protecting Your Digital Services",
  slug: "api-security-best-practices-digital-services",
  category: "Cybersecurity",
  author: "CNGTPL Security Team",
  date: "2025-01-09",
  readTime: "9 min read",
  excerpt: "Essential security measures for APIs including authentication, authorization, rate limiting, input validation, and protecting against common vulnerabilities.",
  image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800"
},
{
  id: 19,
  title: "Social Engineering Attacks: How to Train Your Team to Spot Threats",
  slug: "social-engineering-attacks-training-team",
  category: "Cybersecurity",
  author: "CNGTPL Security Team",
  date: "2025-01-06",
  readTime: "6 min read",
  excerpt: "Understanding phishing, pretexting, and other social engineering tactics. Learn how to build a security-aware culture through effective training programs.",
  image: "https://images.unsplash.com/photo-1516321497487-e288fb19713f?w=800"
},
{
  id: 20,
  title: "Cloud Security Essentials: AWS, Azure, and GCP Best Practices",
  slug: "cloud-security-essentials-aws-azure-gcp",
  category: "Cybersecurity",
  author: "CNGTPL Security Team",
  date: "2025-01-02",
  readTime: "10 min read",
  excerpt: "Master cloud security fundamentals including IAM policies, encryption, network security groups, compliance, and monitoring across major cloud platforms.",
  image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800"
},
{
  id: 21,
  title: "Penetration Testing Explained: What Every Business Owner Should Know",
  slug: "penetration-testing-explained-business-owners",
  category: "Cybersecurity",
  author: "CNGTPL Security Team",
  date: "2024-12-30",
  readTime: "7 min read",
  excerpt: "Demystifying penetration testing - learn what it is, why you need it, what to expect during a pentest, and how to act on the findings.",
  image: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=800"
},
{
  id: 22,
  title: "Security Compliance 101: ISO 27001, SOC 2, and GDPR Essentials",
  slug: "security-compliance-iso-soc2-gdpr",
  category: "Cybersecurity",
  author: "CNGTPL Security Team",
  date: "2024-12-27",
  readTime: "8 min read",
  excerpt: "Navigate the complex world of security compliance certifications and understand what's required to achieve and maintain ISO 27001, SOC 2, and GDPR compliance.",
  image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800"
},
{
  id: 23,
  title: "Solar Energy for Businesses: Complete ROI Guide 2025",
  slug: "solar-energy-businesses-roi-guide-2025",
  category: "Solar Energy",
  author: "CNGTPL Solar Team",
  date: "2025-04-15",
  readTime: "10 min read",
  excerpt: "Comprehensive guide to solar ROI for commercial installations including payback periods, government subsidies, tax benefits, and real case studies from Indian businesses.",
  image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800"
},
{
  id: 24,
  title: "Government Solar Subsidies in India: Complete Guide 2025",
  slug: "government-solar-subsidies-india-2025",
  category: "Solar Energy",
  author: "CNGTPL Solar Team",
  date: "2025-04-12",
  readTime: "8 min read",
  excerpt: "Latest information on central and state government solar subsidies, eligibility criteria, application process, and how to maximize your solar incentives in India.",
  image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?w=800"
},
{
  id: 25,
  title: "Rooftop Solar Installation: Everything You Need to Know",
  slug: "rooftop-solar-installation-complete-guide",
  category: "Solar Energy",
  author: "CNGTPL Solar Team",
  date: "2025-04-09",
  readTime: "12 min read",
  excerpt: "Step-by-step guide to rooftop solar installations including site assessment, system sizing, inverter selection, net metering, and maintenance requirements.",
  image: "https://images.unsplash.com/photo-1559302504-64aae6ca6b6d?w=800"
},
{
  id: 26,
  title: "EV Charging Infrastructure: Business Opportunities in India",
  slug: "ev-charging-infrastructure-business-opportunities",
  category: "Green Energy",
  author: "CNGTPL Energy Team",
  date: "2025-04-06",
  readTime: "9 min read",
  excerpt: "Explore the booming EV charging business in India - installation costs, revenue models, government schemes, and how to start your EV charging station.",
  image: "https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=800"
},
{
  id: 27,
  title: "Solar Panel Maintenance: Tips to Maximize Efficiency",
  slug: "solar-panel-maintenance-maximize-efficiency",
  category: "Solar Energy",
  author: "CNGTPL Solar Team",
  date: "2025-04-03",
  readTime: "7 min read",
  excerpt: "Essential solar panel maintenance practices including cleaning schedules, inspection checklists, troubleshooting common issues, and extending panel lifespan.",
  image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800"
},
{
  id: 28,
  title: "Energy Storage Solutions: Batteries for Solar Power Systems",
  slug: "energy-storage-solutions-solar-batteries",
  category: "Green Energy",
  author: "CNGTPL Energy Team",
  date: "2025-03-30",
  readTime: "10 min read",
  excerpt: "Complete guide to solar battery storage systems including lithium-ion vs lead-acid, sizing calculations, costs, and how to achieve energy independence.",
  image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800"
}];